import { CadastroEndpoints } from '../types/Endpoints';

import { RequestService } from 'itaf';

const extraHeaders = {
  'x-app': 'bridge'
};

class CadastroService {
  fetchDashboardCnpjData() {
    const API_URL = CadastroEndpoints.Graphics;
    return RequestService.getRequest(`${API_URL}/situacao`, {}, extraHeaders);
  }

  fetchDashboardCnpjRegimes() {
    const API_URL = CadastroEndpoints.Graphics;
    return RequestService.getRequest(`${API_URL}/regimes`, {}, extraHeaders);
  }
}

export default new CadastroService();
